import { render } from "./UserAssignForm.vue?vue&type=template&id=08a31418&scoped=true"
import script from "./UserAssignForm.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAssignForm.vue?vue&type=script&setup=true&lang=js"

import "./UserAssignForm.vue?vue&type=style&index=0&id=08a31418&scoped=true&lang=css"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a31418"],['__file',"resources/js/modules/coaching_user/components/UserAssignForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08a31418"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08a31418', __exports__)) {
    api.reload('08a31418', __exports__)
  }
  
  module.hot.accept("./UserAssignForm.vue?vue&type=template&id=08a31418&scoped=true", () => {
    api.rerender('08a31418', render)
  })

}


export default __exports__